import * as fromAuth from '../actions/auth.actions';

export interface AuthState {
    isUserLoggedIn: boolean;
}

const initialState: AuthState = {
    isUserLoggedIn: false,
};

export function authReducer( state: AuthState = initialState, action: fromAuth.authActions ): AuthState {
    switch ( action.type ) {
    case fromAuth.LOGIN_USER:
        return {
            isUserLoggedIn: true
        };

    case fromAuth.LOGOUT_USER:
        return {
            isUserLoggedIn: false
        };

    default:
        return state;
    }
}
